import { Flex, styled } from "@acko-tech/building-blocks.ui.common";
import { useOnload } from "@utils/useOnLoad";
import DOMPurify from "isomorphic-dompurify";
import { resolvePath } from "@utils/resolvePath";

const Container = styled(Flex)`
  padding: 12px;
  margin-top: 15px;
  flex-direction: row;
  box-sizing: border-box;
  border-radius: 12px;
  color: #5b5675;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  width: 100%;
  border: 1px solid #e7e7f0;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  span {
    font-weight: 600;
    color: #7c47e1;
  }
`;

const Heading = styled(Flex)`
  color: #040222;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
`;

const ModifyModal = ({ children, ...props }) => {
  const {
    heading,
    text,
    offeredAddons,
    isAddonText = false,
    actions,
    is_visible
  } = props;
  const { on_click } = actions || {};

  const addons = offeredAddons || [];
  const totalAddons = addons.length;

  const addonName = addons[0]?.display_name || "";
  const moreCount = totalAddons > 1 ? totalAddons - 1 : 0;

  const addonTextValue =
    moreCount > 0
      ? `${addonName} and ${moreCount} more cover${moreCount > 1 ? "s" : ""} available`
      : `${addonName}`;

  const handleClick = () => {
    if (on_click?.length > 0) {
      on_click.forEach((eachFunc) => {
        if (typeof eachFunc.funCall === "function") {
          eachFunc.funCall(eachFunc.args);
        }
      });
    }
  };

  return is_visible ? (
    <Container onClick={handleClick}>
      <div style={{ flexDirection: "column" }}>
        <Heading>{heading}</Heading>
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(isAddonText ? addonTextValue : text)
          }}
        />
      </div>
      <img src={resolvePath("/images/Chevron_right.svg")} alt="right_arrow" />
    </Container>
  ) : null;
};

export default ModifyModal;
